@if(status?.name) {
<div class="flex flex-col gap-1">
  <span class="inline-flex items-center gap-2 w-fit">
    <span class="h-3 w-1 rounded-full shrink-0 opacity-80" [style.background-color]="status?.color || '#9ca3af'">
    </span>
    <span class="text-sm leading-none  ">{{ status?.name }}</span>
  </span>
  <span class="text-xs leading-none opacity-80 pl-3">{{ status?.date | date:'dd/MM/yyyy HH:mm' }}</span>
</div>

}
